function updateOverlayScrollProgress(overlay, progressBar) {
  const overlayHeight = overlay.getBoundingClientRect().height;
  const percentageVisible = (overlay.scrollTop + overlayHeight) / overlay.scrollHeight;
  const barHeight = percentageVisible * overlayHeight;
  // eslint-disable-next-line no-param-reassign
  progressBar.style.height = `${Math.round(barHeight)}px`;
}

let currentOverlayScrollListener = null;

function showGalleryOverlay(overlay) {
  // allow transition
  overlay.setAttribute('data-gallery-overlay-fade', true);
  overlay.setAttribute('data-gallery-overlay-visible', true);
  // trigger transition
  setTimeout(() => {
    overlay.removeAttribute('data-gallery-overlay-fade');
  }, 1);

  // add scroll listener
  const progressBar = overlay.querySelector('[data-gallery-overlay-progress-bar]');
  updateOverlayScrollProgress(overlay, progressBar);
  currentOverlayScrollListener = () => {
    updateOverlayScrollProgress(overlay, progressBar);
  };
  overlay.addEventListener('scroll', currentOverlayScrollListener);

  // add no-scroll body class
  document.body.classList.add('has-overlay');
}

function hideGalleryOverlay(overlay) {
  overlay.setAttribute('data-gallery-overlay-fade', true);
  // finish transition
  window.setTimeout(() => {
    overlay.removeAttribute('data-gallery-overlay-fade');
    overlay.removeAttribute('data-gallery-overlay-visible');
  }, 300);

  // remove scroll listener
  overlay.removeEventListener('scroll', currentOverlayScrollListener);
  currentOverlayScrollListener = null;

  // remove no-scroll body class
  document.body.classList.remove('has-overlay');
}

function hideAllGalleryOverlays() {
  document.querySelectorAll('[data-gallery-overlay-visible]').forEach((overlay) => {
    hideGalleryOverlay(overlay);
  });
}

export default { showGalleryOverlay, hideGalleryOverlay, hideAllGalleryOverlays };


document.querySelectorAll('[data-gallery-overlay-show]').forEach((button) => {
  const selector = button.getAttribute('data-gallery-overlay-show');
  const overlay = document.querySelector(selector);
  button.addEventListener('click', () => { showGalleryOverlay(overlay); });
});

document.querySelectorAll('[data-gallery-overlay-hide]').forEach((button) => {
  const selector = button.getAttribute('data-gallery-overlay-hide');
  const overlay = document.querySelector(selector);
  button.addEventListener('click', () => { hideGalleryOverlay(overlay); });
});

document.querySelectorAll('[data-gallery-overlay-hide-all]').forEach((button) => {
  button.addEventListener('click', hideAllGalleryOverlays);
});
